import { Features } from '@/entities/features/model';
import { ref } from 'vue';
import { pipe } from 'fp-ts/function';
import { get as getFeatures } from '@/services/api/resources/features/actions';
import { map } from 'fp-ts/TaskEither';
import {
  INTEGRATIONS_ENABLED,
  SSO_ENABLED,
  ANALYTICS_ENABLED,
  ONBOARDING_ENABLED,
  AI_TEMPLATE_ENABLED,
  ENTITIES_UPLOAD_ENABLED,
  ENTITY_TYPE_OF_RESPONSE_ENABLED,
  SESSION_LIMITATION_ENABLED,
  AVERAGE_WEIGHTED_SCORE_CALCULATION_ENABLED,
  TBR_ENABLED,
  FILE_TYPE_OF_RESPONSE_ENABLED,
  DISABLE_FREE_PLAN_ENABLED,
  APPROVALS_ENABLED,
  DISCOUNT_FOR_CHURNS_ENABLED,
  REPORT_VIEW_RESTRICTIONS_ENABLED,
  ROCC_SCORING_ENABLED,
  FORM_TRANSLATIONS_ENABLED,
  MANUAL_FORM_TRANSLATIONS_ENABLED,
  RTE_ENABLED,
  AI_PRICING_ENABLED,
  AI_CHAT_ENABLED,
  AI_IMAGE_DESCRIPTION_ENABLED,
  AI_PACK_ENABLED,
  ENTITY_PROPERTIES_ENABLED,
  ENTITY_PROPERTY_PREFILL_ENABLED,
  LAST_LOGIN_ENABLED,
  WORD_TEMPLATE_REPORT_ENABLED,
  AI_BLUR_FACES_ENABLED,
  AI_IMAGE_VALIDATION_ENABLED,
  AI_IMPROVE_WRITING_ENABLED,
} from '@/entities/features/constants';

export const features = ref<Features>({
  sso_enabled: false,
  integrations_enabled: false,
  chargebee_enabled: false,
  analytics_enabled: false,
  onboarding_enabled: false,
  ai_template_enabled: false,
  entities_upload_enabled: false,
  entity_type_of_response_enabled: false,
  session_limitation_enabled: false,
  average_weighted_score_calculation_enabled: false,
  tbr_enabled: false,
  file_type_of_response_enabled: false,
  disable_free_plan_enabled: false,
  approvals_enabled: false,
  discount_for_churns_enabled: false,
  report_view_restrictions_enabled: false,
  rocc_scoring_enabled: false,
  form_translations_enabled: false,
  manual_form_translations_enabled: false,
  rte_enabled: false,
  ai_pricing_enabled: false,
  ai_chat_enabled: false,
  ai_image_description_enabled: false,
  ai_pack_enabled: false,
  entity_properties_enabled: false,
  entity_property_prefill_enabled: false,
  last_login_enabled: false,
  word_template_report_enabled: false,
  ai_blur_faces_enabled: false,
  ai_image_validation_enabled: false,
  ai_improve_writing_enabled: false,
});

export const checkFeatures = () => pipe(
  getFeatures(),
  map(featuresResponse => {
    features.value = featuresResponse.data;
  }),
);

export const isSsoEnabled = () => features.value[SSO_ENABLED];
export const isIntegrationsEnabled = () => features.value[INTEGRATIONS_ENABLED];
export const isAnalyticsEnabled = () => features.value[ANALYTICS_ENABLED];
export const isOnboardingEnabled = () => features.value[ONBOARDING_ENABLED];
export const isAiTemplateEnabled = () => features.value[AI_TEMPLATE_ENABLED];
export const isEntitiesUploadEnabled = () => features.value[ENTITIES_UPLOAD_ENABLED];
export const isEntityTypeOfResponseEnabled = () => features.value[ENTITY_TYPE_OF_RESPONSE_ENABLED];
export const isSessionLimitationEnabled = () => features.value[SESSION_LIMITATION_ENABLED];
export const isWeightedScoreCalculationEnabled = () => features.value[AVERAGE_WEIGHTED_SCORE_CALCULATION_ENABLED];
export const isTbrEnabled = () => features.value[TBR_ENABLED];
export const isFileTypeOfResponseEnabled = () => features.value[FILE_TYPE_OF_RESPONSE_ENABLED];
export const isDisableFreePlanEnabled = () => features.value[DISABLE_FREE_PLAN_ENABLED];
export const areApprovalsEnabled = () => features.value[APPROVALS_ENABLED];
export const isDiscountForChurnsEnabled = () => features.value[DISCOUNT_FOR_CHURNS_ENABLED];
export const isReportViewRestrictionsEnabled = () => features.value[REPORT_VIEW_RESTRICTIONS_ENABLED];
export const isRoccScoringEnabled = () => features.value[ROCC_SCORING_ENABLED];
export const isFormTranslationsEnabled = () => features.value[FORM_TRANSLATIONS_ENABLED];
export const isManualFormTranslationsEnabled = () => features.value[MANUAL_FORM_TRANSLATIONS_ENABLED];
export const isRTEEnabled = () => features.value[RTE_ENABLED];
export const isAiPricingEnabled = () => features.value[AI_PRICING_ENABLED];
export const isLastLoginEnabled = () => features.value[LAST_LOGIN_ENABLED];
export const isAiChatEnabled = () => features.value[AI_CHAT_ENABLED];
export const isAiImageDescriptionEnabled = () => features.value[AI_IMAGE_DESCRIPTION_ENABLED];
export const isAiPackEnabled = () => features.value[AI_PACK_ENABLED];
export const isEntityPropertiesEnabled = () => features.value[ENTITY_PROPERTIES_ENABLED];
export const isEntityPropertyPrefillEnabled = () => features.value[ENTITY_PROPERTY_PREFILL_ENABLED];
export const isWordTemplateReportEnabled = () => features.value[WORD_TEMPLATE_REPORT_ENABLED];
export const isAiBlurFacesEnabled = () => features.value[AI_BLUR_FACES_ENABLED];
export const isAiImageValidationEnabled = () => features.value[AI_IMAGE_VALIDATION_ENABLED];
export const isAiImproveWritingEnabled = () => features.value[AI_IMPROVE_WRITING_ENABLED];
